import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/context/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';

const Header = ({ showBackButton = true, title, backTo = '/menu' }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <header className="sticky top-0 z-50 glass-dark border-b border-border/30">
      <div className="flex items-center justify-between px-4 py-3">
        {/* Left Section */}
        <div className="flex items-center gap-3">
          {showBackButton ? (
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate(backTo)}
              className="text-foreground hover:text-primary hover:bg-muted/50 rounded-full"
            >
              <ArrowLeft className="w-5 h-5" />
            </Button>
          ) : (
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate('/')}
              className="text-foreground hover:text-primary hover:bg-muted/50 rounded-full"
            >
              <Home className="w-5 h-5" />
            </Button>
          )}

          {/* Title / Logo */}
          <h1 className="font-display text-lg sm:text-xl text-foreground tracking-wide truncate max-w-[180px] sm:max-w-none">
            {title}
          </h1>
        </div>

        {/* Right Section - Language Switcher */}
        <LanguageSwitcher variant="header" />
      </div>
    </header>
  );
};

export default Header;
